<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'ItemAttributeComponent.vue'
}
</script>

<style scoped></style>
